import { render, staticRenderFns } from "./CustomerPopin.vue?vue&type=template&id=1842f850&"
import script from "./CustomerPopin.vue?vue&type=script&lang=js&"
export * from "./CustomerPopin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1842f850')) {
      api.createRecord('1842f850', component.options)
    } else {
      api.reload('1842f850', component.options)
    }
    module.hot.accept("./CustomerPopin.vue?vue&type=template&id=1842f850&", function () {
      api.rerender('1842f850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/CustomerPopin.vue"
export default component.exports